import React, { useState, useEffect } from 'react';
import NewPrescription from './Newprescription'; // adjust the path if needed

const prescriptions = [
  {
    id: '#12345',
    name: 'Sarah Wilson',
    medication: 'Adderall XR',
    dosage: '20mg',
    prescribed: 'July 15, 2025',
    expires: 'August 15, 2025',
    status: 'active',
    refillText: '2 refills left',
    notes: 'Start with 10mg; increase if tolerated.',
  },
  {
    id: '#12346',
    name: 'Michael Brown',
    medication: 'Zoloft',
    dosage: '50mg',
    prescribed: 'July 10, 2025',
    expires: 'August 10, 2025',
    status: 'expiring',
    refillText: 'Needs renewal',
    notes: 'Take with food. Monitor for side effects.',
  },
  {
    id: '#12347',
    name: 'Emma Davis',
    medication: 'Cymbalta',
    dosage: '30mg',
    prescribed: 'June 15, 2025',
    expires: 'July 15, 2025',
    status: 'expired',
    refillText: 'Expired',
    notes: 'Complete current prescription before renewal.',
  },
];

const statusStyles = {
  active: 'bg-green-100 text-green-700',
  expiring: 'bg-yellow-100 text-yellow-700',
  expired: 'bg-red-100 text-red-700',
};

const Prescriptions = () => {
  const [showModal, setShowModal] = useState(false);

  const openForm = () => setShowModal(true);
  const closeForm = () => setShowModal(false);

// useEffect(() => {
//   document.body.style.overflow = showModal ? 'hidden' : 'auto';
//   return () => {
//     document.body.style.overflow = 'auto';
//   };
// }, [showModal]);

  return (
    <div className="min-h-screen  ">
      {/* Header */}
      <div className="mb-6 md:mb-8">
        <h1 className="text-2xl font-semibold text-gray-800">Prescriptions</h1>
        <p className="text-gray-600 mt-1">Manage medications and track refill status.</p>
      </div>

      {/* Filters */}
 <div className="flex flex-wrap items-center gap-4 mb-6">
  {/* Status Dropdown */}
  <div className="relative inline-block w-40">
    <select className="appearance-none w-full border border-gray-300 rounded-md px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white pr-10">
      <option>All Status</option>
      <option>Active</option>
      <option>Expired</option>
      <option>Expiring</option>
    </select>
    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
      <svg className="w-4 h-4 text-black" fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
      </svg>
    </div>
  </div>

  {/* Date Range Dropdown */}
  <div className="relative inline-block w-35">
    <select className="appearance-none border border-gray-300 rounded-md px-4 py-2 pr-10 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white w-full">
      <option>Date Range</option>
    </select>
    <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
      <svg className="w-4 h-4 text-black" fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
      </svg>
    </div>
  </div>

  {/* Sort By Dropdown */}
  <div className="relative inline-block w-30">
    <select className="appearance-none border border-gray-300 rounded-md px-4 py-2 pr-10 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white w-full">
      <option>Sort By</option>
    </select>
    <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
      <svg className="w-4 h-4 text-black" fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
      </svg>
    </div>
  </div>

  {/* Button pushed to right */}
  <div className="ml-auto">
    <button
      onClick={openForm}
      className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 text-sm"
    >
      + New Prescriptions
    </button>
  </div>
</div>


      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {prescriptions.map((item) => (
          <div
            key={item.id}
            className="bg-white p-6 rounded-lg shadow border border-gray-200 flex flex-col justify-between"
          >
            <div>
              <div className="flex justify-between items-center mb-2">
                <h3 className="text-md font-semibold text-gray-800">{item.name}</h3>
                <span className={`text-xs px-2 py-1 rounded-full font-medium ${statusStyles[item.status]}`}>
                  {item.status}
                </span>
              </div>
              <p className="text-sm text-gray-600">{item.id}</p>
              <p className="mt-2 font-medium text-gray-700">{item.medication}</p>
              <p className="text-sm text-gray-500">{item.dosage}</p>

              <div className="flex gap-6 text-sm text-gray-600 mt-3 justify-between">
                <div>
                  <p className="font-medium">Prescribed</p>
                  <p>{item.prescribed}</p>
                </div>
                <div className="text-center w-full">
                  <p className="font-medium">Expires</p>
                  <p>{item.expires}</p>
                </div>
              </div>

              <div className="mt-3 text-sm">
                <p className={`font-medium ${item.status === 'expired' ? 'text-red-600' : 'text-green-600'}`}>
                  {item.refillText}
                </p>
              </div>

              <div className="bg-gray-50 p-3 text-sm text-gray-600 rounded mt-3">{item.notes}</div>
            </div>

            {/* Action Buttons */}
            <div className="grid grid-cols-3 gap-4 mt-4">
              <button className="text-blue-600 border border-blue-500 px-4 py-2 rounded hover:border-blue-600 text-sm w-full">
                View Details
              </button>

              <button className="text-gray-600 hover:text-gray-800 text-sm flex items-center gap-1 w-full justify-center">
                <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                  <path d="M19 21H5a2 2 0 01-2-2V7a2 2 0 012-2h4l2-2h2l2 2h4a2 2 0 012 2v12a2 2 0 01-2 2z" />
                </svg>
         Download PDF
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Modal */}
      {showModal && (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-10 flex items-center justify-center">
  <div className=" h-full bg-white  overflow-y-auto relative">
    {/* Modal Header */}
    <div className="flex  sticky top-0 e z-10">
 <div className="ml-auto">
        <button
          onClick={closeForm}
          className="text-gray-500 hover:text-gray-700 text-2xl font-bold"
          aria-label="Close"
        >
          &times;
        </button>
      </div> 
    </div>

    {/* Form Content */}
    <div className="">
      <NewPrescription />
    </div>
  </div>
</div>

      )}
    </div>
  );
};

export default Prescriptions;
